import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "document",
  "use": "document-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"document\"><g fill-rule=\"evenodd\"><path d=\"M10.91 4.009v3.34h3.52l-6.47 7.91-6.45-7.91h3.52v-3.34H0v11.96h15.94V4.009z\" /><path d=\"M6.332 0v8.653H4.25l3.711 4.554 3.728-4.554H9.605V0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id